export const SIDEBARS_TOP = [
    {
        title: 'Dashboard',
        link : '/'
    },
    {
        title: 'Profile',
        link : '/settings/profile'
    }
];

export const SIDEBARS_TOP_EXAM_PREP = [
    {
        title: 'Dashboard',
        link : '/'
    },
    {
        title: 'Profile',
        link : '/settings/profile'
    }
];

export const SIDEBARS_TOP_GUEST = [
    {
        title: 'Dashboard',
        link : '/'
    }
];

export const SIDEBARS_BOTTOM = [
    {
        title: 'Payments',
        link : '/settings/payments'
    },
    {
        title: 'About Us',
        link : '/about-us'
    },
    {
        title: 'Contact Us',
        link : '/contact-us'
    },
    {
        title: 'Log out',
        link : '/logout'
    }
];

export const SIDEBARS_BOTTOM_GUEST = [
    {
        title: 'About Us',
        link : '/about-us'
    },
    {
        title: 'Contact Us',
        link : '/contact-us'
    },
];


export const BUTTONS = [
    {
        title: 'Sign Up',
        link : '/signUp'
    },
    {
        title: 'Sign In',
        link : '/signIn'
    }
];



// WEBPACK FOOTER //
// ./src/constants/sideBar.js